/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_AllInputs */

const en_services_all = /** @type {(inputs: Services_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All sessions`)
};

const pl_services_all = /** @type {(inputs: Services_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie zajęcia`)
};

/**
* | output |
* | --- |
* | "All sessions" |
*
* @param {Services_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_all = /** @type {((inputs?: Services_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_all(inputs)
	return en_services_all(inputs)
});